import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {AppThunk} from 'app/store';
import {endLoading, startLoading, } from 'app/apiSlice';
import {getUsers, addOrUpdateUser} from 'api';
import {User} from '../../interfaces/models';
import {UserDto} from '../../interfaces/dto';
import errorHandler from '../shared/errorHandler';

interface UserManagementState {
    users: User[]
}

const initialState: UserManagementState = {
    users: []
};

const userManagementSlice = createSlice({
   name: 'userManagement',
   initialState,
   reducers: {
       setUsers: (state: UserManagementState, action: PayloadAction<User[]>) => {
           state.users = action.payload;
       }
   } 
});

export default userManagementSlice.reducer;

export const fetchUsers = (): AppThunk<void> => async (dispatch, getState) => {
    const token = getState().oidc.user?.access_token;
    if (!token) return;
    dispatch(startLoading('fetchUsers'));
    try {
        const response = await getUsers(token);
        dispatch(userManagementSlice.actions.setUsers(response.data));
    } catch (err) {
        errorHandler('fetchUsers error', err);
    }
    dispatch(endLoading('fetchUsers'));
};

export const createOrUpdateUser = (data: UserDto): AppThunk<void> => async (dispatch, getState) => {
    const token = getState().oidc.user?.access_token;
    if (!token) return;
    dispatch(startLoading('createOrUpdateUser'));
    try {
        const response = await addOrUpdateUser(token, data);
        if (response.success) {
            await dispatch(fetchUsers());
        }
    } catch (err) {
        errorHandler('addUser error', err);
    }
    dispatch(endLoading('createOrUpdateUser'));
};